import type { RouteRecordRaw, Router } from 'vue-router'

const EstateExchangeContractRoutes: RouteRecordRaw = {
  path: '/contract/estate/exchange',
  name: 'EstateExchangeModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'EstateExchangeMainRoute',
      component: () => import('./views/AccordView.vue'),
      meta: {
        title: 'exchangeEstate.exchangeContract',
      },
    },
    {
      path: 'create',
      name: 'EstateExchangeCreateRoute',
      component: () => import('./views/AccordUpsertView.vue'),
      meta: {
        title: 'exchangeEstate.createExchangeContract',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:accordId',
      name: 'EstateExchangeEditRoute',
      component: () => import('./views/AccordUpsertView.vue'),
      meta: {
        title: 'exchangeEstate.editExchangeContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:accordId',
      name: 'ViewEstateExchangeRoute',
      component: () => import('./views/SingleAccordView.vue'),
      meta: {
        title: 'exchangeEstate.ViewExchange',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(EstateExchangeContractRoutes)
}
